import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import { allModulosAction, setActivoModulosAction } from './ModulosAction';
import FormModulos from './components/FormModulos';
import ListadoModulos from './components/ListadoModulos';

const ModulosView = () => {
  const dispatch = Redux.useDispatch();

  const modulosStore = Redux.useSelector((state) => state.modulos);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoModulosAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          addIcon
          mr={2}
        />
        <BotonComponent
          click={async () => {
            await setActivoModulosAction(dispatch, null);
            await allModulosAction(dispatch, modulosStore.params);
          }}
          disabled={modulosStore.all.length === 0 || modulosStore.loadingAll}
          white
          refreshIcon
          text={modulosStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={12}>
        <ListadoModulos setOpenModalForm={(value) => setOpenModalForm(value)} />
      </Grid>
      <ModalComponent
        id="modalFormModulos"
        title={
          modulosStore.activo
            ? `Editar ${modulosStore.activo.nombre}`
            : 'Nuevo módulo del sistema'
        }
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormModulos
          activo={modulosStore.activo}
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default ModulosView;
